import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as commercialManagementActions from 'action/commercialManagement'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import CommercialManagement from 'component/report/commercialManagement/CommercialManagement'
import CommercialManagementHeader from 'component/report/commercialManagement/CommercialManagementHeader'
import PeriodPickerCommercialManagement from 'component/report/commercialManagement/PeriodPickerCommercialManagement'
import FeedbackError from 'component/utils/FeedbackError'

class CommercialManagementContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchCommercialManagements: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    commercialManagement: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
  }

  state = {
    filters: {},
    filtersVisible: true,
  }

  toggleFilters = () => {
    this.setState((prevState) => ({
      filtersVisible: !prevState.filtersVisible,
    }))
  }

  getCsv = () => {
    const {
      fetchReports,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 3,
    }

    fetchReports(user.dsToken, values, this.state.filters)
  }

  getPdf = () => {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 4,
    }

    fetchReports(user.dsToken, values, filters)
  }

  handleFetchCommercialManagements = async (values) => {
    const { fetchCommercialManagements, auth } = this.props

    await fetchCommercialManagements(auth, values)

    this.setState(
      { commercialManagement: this.props.commercialManagement },
      () => {
        this.setState({filters:values})
        this.toggleFilters()
      }
    )
  }

  renderError(message) {
    /* istanbul ignore else */
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  render() {
    const { translate, error, commercialManagement, filters, auth } = this.props

    const { filtersVisible } = this.state

    return (
      <section>
        <ContentHeader>
          {translate('commercial-management.title')}
        </ContentHeader>

        <CommercialManagementHeader translate={translate} />

        {error && this.renderError(error.message)}

        {filtersVisible && (
          <PeriodPickerCommercialManagement
            translate={translate}
            fetchCommercialManagements={this.handleFetchCommercialManagements}
            auth={auth}
          />
        )}

        {!filtersVisible && (
          <CommercialManagement
            translate={translate}
            commercialManagement={commercialManagement}
            getCsv={this.getCsv}
            getPdf={this.getPdf}
            newSearch={this.toggleFilters}
            filters={filters}
            values={this.state.filters}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = (
  { commercialManagementReducer, reportReducer },
) =>
  /* istanbul ignore next */
  ({
    commercialManagement: commercialManagementReducer.record,
    error: commercialManagementReducer.error,
    filters: commercialManagementReducer.filters,
    report: reportReducer.get.record,
  })

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  /* istanbul ignore next */ bindActionCreators(
    { ...commercialManagementActions, ...reportActions },
    dispatch
  )

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const CommercialManagementTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(CommercialManagementContainer)

/*
 * Exports component connected to redux as default
 */
/* istanbul ignore next */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommercialManagementTranslated)

export { CommercialManagementContainer }
